function Preload({ images, fonts, styles }) {
  return (
    <>
      {/* Preload images */}
      {images?.map((image, index) => (
        image.media ? (
          <link
            key={`img-${index}`}
            rel="preload"
            as="image"
            href={image.src}
            media={image.media}
          />
        ) : (
          <link
            key={`img-${index}`}
            rel="preload"
            as="image"
            href={image.src}
          />
        )
      ))}

      {/* Preload fonts */}
      {fonts?.map((font, index) => (
        <link
          key={`font-${index}`}
          rel="preload"
          as="font"
          href={font.src}
          type={font.type || "font/woff2"}
          crossOrigin="anonymous"
        />
      ))}

      {/* Preload CSS */}
      {styles?.map((style, index) => (
        <link
          key={`style-${index}`}
          rel="preload"
          as="style"
          href={style}
        />
      ))}
    </>
  );
}

export default Preload; 